import './SearchResults.scss';

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Button from 'components/Button';
import Icon from 'components/Icon';
import {IMAGE_SIZES} from "../../../../utils/constants";

const backgrounds = [
    `${process.env.REACT_APP_WEBSITE_URL}/wp-content/themes/kaya-child/img/nobanner/bg0.jpg`,
    `${process.env.REACT_APP_WEBSITE_URL}/wp-content/themes/kaya-child/img/nobanner/bg1.jpg`,
    `${process.env.REACT_APP_WEBSITE_URL}/wp-content/themes/kaya-child/img/nobanner/bg2.jpg`,
    `${process.env.REACT_APP_WEBSITE_URL}/wp-content/themes/kaya-child/img/nobanner/bg3.jpg`
];

const SearchResults = ({epiloggs}) => {
    return (
        <div className="search-results">
            {epiloggs.map((epilogg) => (
                <div
                    className="search-results__epilogg"
                    key={epilogg.id}
                    onClick={() => window.location.href = `${process.env.REACT_APP_WEBAPP_URL}/obituary/${epilogg.slug}`}
                >
                    <div className="search-results__epilogg-header" style={epilogg.bannerPicArtifact ? {backgroundImage: `url(${epilogg.bannerPicArtifact.url.replace('/original/', IMAGE_SIZES.BANNER)})`} : {backgroundImage: `url(${backgrounds[epilogg.id % 4]})`}}>
                        <div className="search-results__epilogg-avatar" style={epilogg.profilePicArtifact ? {backgroundImage: `url(${epilogg.profilePicArtifact.url.replace('/original/', IMAGE_SIZES.AVATAR)})`} : {backgroundImage: `url(${process.env.REACT_APP_WEBSITE_URL}/wp-content/themes/kaya-child/img/noimage/default_avatar_img1.svg)`}} />
                    </div>

                    <div className="search-results__epilogg-content-wrapper">

                        <h2 className="search-results__epilogg-name">
                            {epilogg.displayName || ''}
                        </h2>

                        {epilogg.locationAddress ? (
                            <div className="search-results__epilogg-content">
                                <strong>city/state: </strong>{epilogg.locationAddress}
                            </div>
                        ) : null}

                        {epilogg.dateOfDeath ? (
                            <div className="search-results__epilogg-content">
                                <strong>date of death: </strong>{moment(epilogg.dateOfDeath.substring(0, 10)).format('MM/DD/YYYY')}
                            </div>
                        ) : null}

                        <Button
                            className="search-results__epilogg-view-button"
                            href={`${process.env.REACT_APP_WEBAPP_URL}/obituary/${epilogg.slug}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            View Epilogg
                        </Button>
                    </div>
                </div>
            ))}
        </div>
    );
};

SearchResults.propTypes = {
    epiloggs: PropTypes.array.isRequired
};

export default SearchResults;
